import { render, staticRenderFns } from "./DistributionByLOLCard.vue?vue&type=template&id=b7ff9378&scoped=true&"
import script from "./DistributionByLOLCard.vue?vue&type=script&lang=js&"
export * from "./DistributionByLOLCard.vue?vue&type=script&lang=js&"
import style0 from "./DistributionByLOLCard.vue?vue&type=style&index=0&id=b7ff9378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ff9378",
  null
  
)

export default component.exports